<template>
  <div class="school-info ma-0 p-3">
    <v-card>
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t("manage.by_school.school_info.table_header.id") }}
            </th>
            <th class="text-left">
              {{ $t("manage.by_school.school_info.table_header.full_name") }}
            </th>
            <th class="text-left">
              {{ $t("manage.by_school.school_info.table_header.full_name_chi") }}
            </th>
            <th class="text-left">
              {{ $t("manage.by_school.school_info.table_header.school_logo") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ api.school_id }}</td>
            <td>{{ api.school_name }}</td>
            <td>{{ api.school_chi_name }}</td>
            <td><v-btn @click="openViewLogoDialog" class="green lighten-4">{{ $t("manage.by_school.school_info.btn_view_logo") }}</v-btn></td>
          </tr>
        </tbody>
      </v-simple-table>
    <hr>
    </v-card>
    <v-dialog v-model="dialog_view_logo" persistent max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeViewLogoDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.school_info.school_logo.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" md="8" lg="6" class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <table>
                  <tr>
                    <td><b>{{ $t("manage.by_school.school_info.school_logo.school") }}</b></td>
                    <td v-if="$i18n.locale=='tc'" class="pl-3">{{ api.school_chi_name }}</td>
                    <td v-else class="pl-3">{{ api.school_name }}</td>
                  </tr>
                </table>
              </v-col>
              <v-col cols="12">
                <v-card>
                <v-img v-if="api.school_logo_url!=''" :src="api.school_logo_url" class="mx-auto" max-width="200px"></v-img>
                <div v-else ><small><v-icon color="error">mdi-close</v-icon>{{ $t("manage.by_school.school_info.school_logo.no_logo") }}</small></div>
                </v-card>
              </v-col>
              <v-col cols="12">
                <small>* {{ $t("manage.by_school.school_info.school_logo.suggested_dimension") }}</small>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn v-if="api.school_logo_url!=''" color="error" text @click="dialog_remove_logo = true; dialog_view_logo = !dialog_view_logo">
            {{ $t("manage.by_school.school_info.school_logo.btn_remove") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="uploadSchoolLogo">
            {{ $t("manage.by_school.school_info.school_logo.btn_upload") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_remove_logo" persistent max-width="500px" >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ $t("manage.by_school.school_info.school_logo.remove.header") }}
        </v-card-title>
        <v-card-text>
          <v-alert class="mt-4" type="error"
            >{{ $t("manage.by_school.school_info.school_logo.remove.alert") }}
          </v-alert>
          {{ $t("manage.by_school.school_info.school_logo.remove.school") }} <b>{{ current.school_id }}</b>
        </v-card-text>

        <v-divider></v-divider>
        
        <v-card-actions>
          <v-btn color="primary" text @click="dialog_remove_logo=!dialog_remove_logo; dialog_view_logo = true">{{ $t("manage.by_school.school_info.school_logo.remove.btn_discard") }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="removeSchoolLogo">{{ $t("manage.by_school.school_info.school_logo.remove.btn_confirm") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <input
      ref="file"
      type="file"
      accept="image/*"
      @change="uploadLogoToServer()"
      hidden
    />
  </div>
</template>
<script>

import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

export default {
  name: "experiment",
  components: {
  },
  mixins: [],
  data: function () {
    return {
      school_id: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      dialog_view_logo: false,
      dialog_remove_logo: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      admin: false,
      user: [{
        name: null,
        level: null,
      }],
      form: {
        school: "",
        experiment: "",
        equipment_id: "",
        next: "",
        status: "",
      },
      api:{
        ref: "",
        school_id: "",
        school_name: "",
        school_chi_name: "",
        school_logo_url: "",
        schools:[],
        experiments:[{field: "BIOLOGY", experiment: "BACTERIA_GROWTH", experiment_name: "Bacteria Growth", status: "ACTIVE",create_at: "2022-09-06 15:55:17"}],
        experiments_list:[],
      },
      headers: [
        { text: 'School', value: 'school' },
        { text: 'Experiment', value: 'experiment' },
        { text: 'Equipment ID', value: 'equipment_id' },
        { text: 'Create At', value: 'create_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;

    self.api.schools = [self.current.school_id];

    self.form.school_id = self.$route.params.school_id
    self.getSchoolInfo();
  },
  methods: {
    getSchoolInfo(){
      var self = this;
      apiManagement
        .getSchoolInfo(self.current.school_id)
        .then((response) => {
          self.api.ref = response.ref;
          self.api.school_id = response.school_id;
          self.api.school_name = response.school_name;
          self.api.school_chi_name = response.school_chi_name;
          if(JSON.parse(response.school_logo)!=null){
            self.api.school_logo_url = JSON.parse(response.school_logo).url;
          }
          else {
            self.api.school_logo_url = "";
          }
          
          self.form.school_id = response.school_id;
          self.form.school_name = response.school_name;
          self.form.school_chi_name = response.school_chi_name;
          self.form.school_logo_url = response.school_logo_url;

        });
    },
    openViewLogoDialog(){
      var self = this;
      self.dialog_view_logo = !self.dialog_view_logo;
    },
    closeViewLogoDialog(){
      var self = this;
      self.dialog_view_logo = !self.dialog_view_logo;
    },    
    uploadSchoolLogo: function () {
      var self = this;
      let fileInputElement = self.$refs.file;
      fileInputElement.click();
    },
    uploadLogoToServer() {
      var self = this;
      let file = self.$refs.file.files[0];
      apiManagement.uploadLogoToServer(self.current.school_id, file)
        .then((response) => {
          if(response.status=="success"){
            self.$store.commit('showSnackBar', "School Logo has been uploaded!");
            self.getSchoolInfo();
          }
          else if(response.status=="fail"){
            alert(response.error);          
          }
          else {
            alert("error");
          }
        });
    },
    removeSchoolLogo() {
      var self = this;
      apiManagement.removeSchoolLogo(self.current.school_id)
        .then((response) => {
          self.dialog_remove_logo = false;
          self.dialog_view_logo = true;

          if(response.status=="success"){
            self.$store.commit('showSnackBar', "School Logo has been removed!");
            self.getSchoolInfo();
          }
          else if(response.status=="fail"){
            alert(response.error);          
          }
          else {
            alert("error");
          }
      });
    },
    back(){
      var self = this;
      self.$cookies.remove("experiment");
      self.$cookies.remove("equipment_id");
      if(self.$route.name == 'admin-school-management'){
        self.$router.push("/admin/management/school/school_list");
      }
      else {
        self.$router.push("/school/school_list");
      }
    },
    tmp(){
      var self = this;
    },
  },
  destroyed(){
    clearInterval(this.kick_inte);
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>